import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NyabDocSearchPageComponent } from './component/nyab-doc-search-page.component';
import { ConfigModule, CmsConfig, I18nModule, OccEndpoint, provideDefaultConfig, FeaturesConfigModule, UrlModule, OccProductSearchAdapter } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, ProductListModule, SortingModule, SpinnerModule, StarRatingModule } from '@spartacus/storefront';
import { KbDocumentGridItemModule } from '../common/components/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../common/components/kb-document-list/kb-document-list.module';
import { RouterModule } from '@angular/router';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NyabPaginationModule } from '../common/components/nyab-pagination/nyab-pagination.module';
import { FacetNavigationModule } from '../common/components/facet-navigation/facet-navigation.module';
import { KbPipesModule } from '../../pipes/kb-pipes.module';




@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        FormsModule,
        ReactiveFormsModule,
        ProductListModule,
        KbDocumentGridItemModule,
        KbDocumentListItemModule,
        SortingModule,
        AtMessageModule,
        FeaturesConfigModule,
        IconModule,
        InfiniteScrollModule,
        ItemCounterModule,
        ListNavigationModule,
        MediaModule,
        OutletModule,
        PageComponentModule,
        RouterModule,
        SpinnerModule,
        StarRatingModule,
        UrlModule,
        NyabPaginationModule,
        FacetNavigationModule,
        KbPipesModule,
        ConfigModule.withConfig(<CmsConfig>{
            cmsComponents: {
                NyabDocumentLibraryFlexComponent: {
                    component: NyabDocSearchPageComponent,
                },
            },
            skipLinks: [],
        }),
        NyabDocSearchPageComponent,
    ],
    providers: [
        OccProductSearchAdapter,
        provideDefaultConfig({
            backend: {
                occ: {
                    endpoints: {
                        getDocumentSearchFormData: '/documentLibrary/kbRaildocument',
                    },
                },
            },
        }),
    ],
})
export class NyabDocSearchPageModule { }

declare module '@spartacus/core' {
  interface OccEndpoints {
    getDocumentSearchFormData?: string | OccEndpoint;
  }
}